import { HideOutlineIcon } from '@carboncopyco/icons';
import type { FrameType } from '@carboncopyco/types';
import { ColorHex, TooltipBubble } from '@carboncopyco/ui';
import Dropdown from './Dropdown';

interface ContextMenuProps {
  isFrameActive: boolean;
  frameHasStepWithJump: boolean;
  activeFramesLength: number;
  frameType: FrameType;
  isFrameConvertable: boolean;
  onDeleteClick: () => void;
  onVisibilityClick: () => void;
  onConvertToFrameClick: () => void;
}

const ContextMenu = ({
  isFrameActive,
  frameHasStepWithJump,
  activeFramesLength,
  frameType,
  isFrameConvertable,
  onDeleteClick,
  onVisibilityClick,
  onConvertToFrameClick,
}: ContextMenuProps) => {
  return (
    <div className="flex items-center">
      {!isFrameActive && (
        <div className="pr-1">
          <TooltipBubble
            placement="top"
            title="Frame is hidden"
          >
            <HideOutlineIcon
              size={16}
              color={ColorHex.natural300}
            />
          </TooltipBubble>
        </div>
      )}
      <Dropdown
        isFrameActive={isFrameActive}
        frameHasStepWithJump={frameHasStepWithJump}
        isFrameConvertable={isFrameConvertable}
        frameType={frameType}
        onVisibilityClick={onVisibilityClick}
        onDeleteClick={onDeleteClick}
        onConvertToFrameClick={onConvertToFrameClick}
        activeFramesLength={activeFramesLength}
      />
    </div>
  );
};

export default ContextMenu;
